import { ERROR_REQUIRED_FIELD } from '@app/constants';

export const NEW_SALES_FUNNEL = 'Новый этап воронки продаж';
export const EDIT_SALES_FUNNEL = 'Редактировать этап воронки продаж';

export const DELETE_SALES_FUNNEL_HAS_LEADS_CONTENT =
  'Удаляемая воронка содержит лиды. При удалении воронки, лиды останутся без воронки!';
export const DELETE_SALES_FUNNEL_STAGE_CONTENT =
  'Вы уверены, что хотите удалить этап воронки продаж?';
export const DELETE_SALES_FUNNEL_CONTENT =
  'Вы уверены, что хотите удалить воронку продаж?';

export const DELETE_SALES_FUNNEL_STAGE_TITLE = 'Удаление этапа воронки продаж';
export const DELETE_SALES_FUNNEL_TITLE = 'Удаление воронки продаж';

export const RULES_IS_REQUIRE = [
  {
    required: true,
    message: ERROR_REQUIRED_FIELD,
  },
];

export const IN_PROGRESS_SELECT_VALUE = 0;
export const SUCCESS_SELECT_VALUE = 1;
export const UNSUCCESS_SELECT_VALUE = 2;

export const CATEGORY_SELECT_OPTIONS = [
  {
    label: 'В работе',
    value: IN_PROGRESS_SELECT_VALUE,
  },
  {
    label: 'Успешные',
    value: SUCCESS_SELECT_VALUE,
  },
  {
    label: 'Неуспешные',
    value: UNSUCCESS_SELECT_VALUE,
  },
];
